/**
 * Bộ layout nộp dự toán
 * NXHung 19.08.2024
 */
export default {
  /// Chi đầu tư
  INVEST: 1,
  /// Chi thường xuyên
  REGULAR: 2,
  /// Chi CTMT, mục tiêu khác
  PROJECT: 3,
  /// Thu - chi từ nguồn hoạt động SN, DV
  BUSINESS: 4,
  /// Thu - chi từ nguồn phí lệ phí
  FEES: 5,
  /// Thu - chi từ nguồn hoạt động SN, DV / tab Thu
  BUSINESS_REVENUE: 41,
  /// Thu - chi từ nguồn hoạt động SN, DV / tab Chi
  BUSINESS_EXPENSE: 42,
  /// Thu - chi từ nguồn phí lệ phí / tab Thu
  FEES_REVENUE: 51,
  /// Thu - chi từ nguồn phí lệ phí / tab Chi
  FEES_EXPENSE: 52,
};
